import React, { useState, useEffect, use } from 'react';
import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';
import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Table,
} from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import './popup.css';
import Select from 'react-select';
import { BlobProvider, pdf } from '@react-pdf/renderer';
import AdmissionFormPDF from './AdmissionFormPDF';
import FeeCardPDF from './FeeCardPDF';
import { formatDate } from '../../constants/DateFormatter';
import { toast } from 'react-toastify';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { batch, useSelector } from 'react-redux';
import useVendorBranch from '../../utils/useVendorBranch';
import conditionalDataLoad from '../../utils/conditionalDataLoad';

const AddAdmissionNew = ({ systemData }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.authState);
  const [admissionResp, setAdmissionResp] = useState({});

  const [selectionData, setSelectionData] = useState({
    vendor_id: '',
    branch_id: '',
  });
  const [sessionOptions, setSessionOptions] = useState([]); // [{value:"2026-2027",label:"2026-2027"}]
  const [selectedSessionYear, setSelectedSessionYear] = useState(''); // ✅ "2026-2027"
  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  // State for each card's toggle
  const [openCards, setOpenCards] = useState({
    studentDetails: true,
    parentsDetails: false,
    feesDetails: false,
    conveyanceDetails: false,
    siblingDetails: false,
    tcDetails: false,
  });

  // Function to toggle specific card
  // const toggleCollapse = (cardId) => {
  //   setOpenCards((prevState) => ({
  //     ...prevState,
  //     [cardId]: !prevState[cardId],
  //   }));
  // }
  const toggleCollapse = (cardId) => {
    setOpenCards((prevState) => ({
      studentDetails: false,
      parentsDetails: false,
      feesDetails: false,
      conveyanceDetails: false,
      siblingDetails: false,
      tcDetails: false,
      [cardId]: !prevState[cardId], // Open only the clicked card
    }));
  };

  const [modal, setModal] = useState(false);

  const sessionData = useSelector((state) => state.sessionState);

  const toggle = () => setModal(!modal);
  const [admissionData, setAdmissionData] = useState({
    id: 0,
    vendor_id: 0,
    branch_id: 0,
    curr_class_id: 0,
    adm_sch_id: 0,
    transport_id: 0,
    session_year: sessionData.session_year,
    admit_no: '',
    stud_name: '',
    sex_mf: '',
    d_o_b: new Date().toISOString().split('T')[0],
    adm_date: sessionData.defaultDate, // Set current date
    class_admit: '',
    curr_class: '',
    curr_sec: '',
    roll_no: '',
    barcode_no: '',
    ac_close_yn: '',
    //ac_close_date: null,
    ac_close_date: new Date('Sat Jul 19 1990 14:00:00 GMT+0200')
      .toISOString()
      .substr(0, 10),
    tc_issue_yn: '',
    //tc_issue_date: null,
    tc_issue_date: new Date('Sat Jul 19 1990 14:00:00 GMT+0200')
      .toISOString()
      .substr(0, 10),
    sadd1: '',
    sadd2: '',
    sadd3: '',
    state_name: '',
    stud_ph_no: '',
    stud_email: '',
    pin_code: '',
    alt_add: '',
    living_dur: '',
    category_class: '',
    religion_name: '',
    mother_tong: '',
    addhar_no: '',
    bank_name: '',
    bank_ac_no: '',
    cov_yn: 'Yes',
    con_det: '',
    fee_group_id: 0,
    slab_code: 0,
    slabMstId: 0,
    fee_flag_type: 0,
    tot_fees: 0,
    op_bal: 0,
    douc_list_det: '',
    f_name: '',
    m_name: '',
    g_name: '',
    f_quali: '',
    m_quali: '',
    g_quali: '',
    f_prof: '',
    m_prof: '',
    g_prof: '',
    f_income: '',
    m_income: '',
    g_income: '',
    f_officeph: '',
    m_officeph: '',
    g_officeph: '',
    f_mob: '',
    m_mob: '',
    g_mob: '',
    //entering_date_time: '',
    last_sch_name: '',
    last_sch_add: '',
    last_sch_city: '',
    last_sch_state: '',
    last_sch_pincode: '',
    last_sch_adm_no: '',
    mark_obtain: 0,
    max_marks: 0,
    last_marks_per: 0,
    sibling_adm_no_1: '',
    sibling_class_1: '',
    sibling_name_1: '',
    sibling_adm_no_2: '',
    sibling_class_2: '',
    sibling_name_2: '',
    sys_remark: '',

    apaar_id: '',
    pen_id: '',
    f_adhaar_no: '',
    m_adhaar_no: '',
    g_adhaar_no: '',

    //samp: 'test ',
  });

  const [Fee_Group_data, setFee_Group_data] = useState([]);
  const [SlabMaster, setSlabMaster] = useState([]);
  const [AdmissinNum, setAdmissinNum] = useState('1');
  const [isUpdate, setisUpadte] = useState(false);
  const [visibale1, setVisibale1] = useState('none');
  const [SlabMasterTotalMont, setSlabMasterTotalMont] = useState({});
  const [MultiPurposeMaster, setMultiPurposeMaster] = useState([]);
  const [religionList, setReligionList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [motherTongueList, setMotherTongueList] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [carList, setcarList] = useState([]);
  const [qualificationList, setQualificationList] = useState([]);
  const [profList, setProfList] = useState([]);
  const [class_MasterData, setClass_MasterData] = useState([]);
  const [class_AdmitData, setClass_AdmitData] = useState([]);
  const [class_SectionData, setClass_SectionData] = useState([]);
  const [popupVisible, setPopupVisible] = useState(false);
  const [conyn_detail, setconyn_detail] = useState('none');
  const [transportList, setTransportList] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [carOptions, setcarOptions] = useState([]);

  const [previewImage, setPreviewImage] = useState(null);

  const handleSelectChange = (selected) => {
    setSelectedOptions(selected);
  };


  const fetchBatches = async () => {
    //setBatches([]);
    try {
      const res = await apiService.get(
        `api/BatchMaster/GetAllBatch?vendorId=${admissionData.vendor_id}&branchId=${admissionData.branch_id}&classId=${admissionData.curr_class_id}&sessionYear=${sessionData.session_year}`,
      );

      //  console.log(res, 'res batch');
      if (res.status === true) {
        const list = res.data || [];
        //console.log(list, 'batch list');
        if (list.length === 1) {
          return list[0]; // Auto-select if only one batch is available
          //alert('Batch list fetched successfully');
        }
        return false;
        //setBatches(list),
      } else {
        toast.error(res.message || 'Failed to fetch batches');
      }
    } catch (err) {
      console.log(err);
      toast.error('Failed to load batches');
    }
  };


  const fetchAdmissionRecord = async (id) => {
    //setBatches([]);
    try {
      const res = await apiService.get(
        `api/Admission/GetSingleRecord?admId=${id}&session=${sessionData.session_year}`,
      );

      //console.log(res, 'res GetSingleRecord');
      if (res.status === true) {
        const admissionDetail = res.admissionDetail || [];
        setAdmissionData(admissionDetail);
        setAdmissionResp(res);
      } else {
        toast.error(res.message || 'Failed to fetch batches');
      }
    } catch (err) {
      console.log(err);
      toast.error('Failed to load batches');
    }
  };

  const [TransportData, setTransportData] = useState({
    id: 0,
    driver_name: '',
    address: '',
    phone_no: '',
    vehicle_no: '',
    car_name: '',
    car_name1: [],
    driving_licence_no: '',
    aadhar_card_no: '',
  });
  const [Multi_Purpose_Type_MasterData, setMulti_Purpose_Type_MasterData] =
    useState({
      multi_purpose_flag: '',
      multi_purpose_code: '',
      multi_purpose_type: '',
      multi_purpose_remark: '',
    });

  // const carOptions = [
  //   { value: ' ', label: ' ' },
  //   { value: 'Toyota', label: 'Toyota' },
  //   { value: 'Honda', label: 'Honda' },
  //   { value: 'General Motors', label: 'General Motors' },
  // ];

  const [siblingTransection, setSiblingTransection] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);

  const [admissinid, setAdmissinId] = useState(0);
  const [siblingAdmid, setSiblingAdmId] = useState('');

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    const reader = new FileReader(file);
    reader.onloadend = () => {
      setPreviewImage(reader.result);
    };
    reader.readAsDataURL(file);
  };

  useEffect(() => {
    // Check if location state exists and set the admissionData accordingly

    if (location.state) {
      //console.log(location.state, 'location.state in add/edit');
      setAdmissionData(location.state);
      fetchAdmissionRecord(location.state.id);
      if (location.state.stud_img_path !== null)
        setSelectedFile(
          process.env.REACT_APP_API_BASE_URL + location.state.stud_img_path,
        );
      setPreviewImage(
        process.env.REACT_APP_API_BASE_URL + location.state.stud_img_path,
      );
      //GetSlabMasterByFeeGroupID(location.state?.fee_group_id);

      if (
        location.state.cov_yn === 'No' ||
        location.state.cov_yn === undefined
      ) {
        setconyn_detail('none');
      } else {
        setconyn_detail('');
      }
      GetSiblingDetailtById(location.state?.id);
      setAdmissinId(location.state?.id);


      if (location.state?.transport_id) {
        //debugger;
        getTransport('', location.state?.transport_id);
      }
      setisUpadte(true);
      setVisibale1('');
    }
  }, [location.state]);

  const GetSiblingDetailtById = async (adm_id) => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };
      const response = await apiService.get(
        `api/SiblingDetails/GetSiblingDetailtById?adm_id=${adm_id}`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }
      if (response.status === true) {
        // const updatedData = response.data1.map((item, index) => ({
        //   ...item,
        //   srNo: index + 1,
        //   adm_date: item.adm_date ? item.adm_date.substring(0, 10) : '', // Check if adm_date is not null
        // }));
        setSiblingTransection(response.data1);
      }
    } catch (error) {
      console.log(error);
      toast.error('SomeThing went wrong!!');
    }
  };

  // ---------- API: Fetch Sessions (session_name) ----------
  const fetchSessions = async (searchText = '') => {
    try {
      const vendorId = admissionData.vendor_id || '';
      const branchId = admissionData.branch_id || '';
      // if (!vendorId || !branchId) {
      //   setSessionOptions([]);
      //   return;
      // }

      const res = await apiService.get(
        `api/SessionMaster/GetAllSession?vendorId=${vendorId}&branchId=${branchId}&search=${encodeURIComponent(
          searchText || '',
        )}`,
      );

      const container = res?.data ?? res;

      const list =
        (Array.isArray(container?.data) && container.data) ||
        (Array.isArray(container?.Data) && container.Data) ||
        (Array.isArray(container) && container) ||
        [];

      const opts = (list || [])
        .map((x) => {
          const name =
            x.session_name ??
            x.sessionName ??
            x.session_year ??
            x.sessionYear ??
            '';
          const s = String(name || '').trim();
          return s ? { value: s, label: s } : null;
        })
        .filter(Boolean);

      // unique
      const unique = Array.from(
        new Map(opts.map((o) => [o.value, o])).values(),
      );
      setSessionOptions(unique);

      setSelectedSessionYear(unique[0]?.value || '');
      // ✅ if redux session exists, auto select (optional)
      // const reduxSession = String(sessionState?.session_year || '').trim();
      // if (reduxSession && !selectedSessionYear) {
      //   setSelectedSessionYear(reduxSession);
      // }
    } catch (err) {
      console.error(err);
      setSessionOptions([]);
    }
  };

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: admissionData.vendor_id,
      branchId: admissionData.branch_id,
    });

    if (!canLoad) return;

    if (!location.state) {
      GetLastAdmissionNo();
    }
    fetchClasses('');
    fetchSessions('');

    GetFee_GroupData();
    //GetSlabMasterByFeeGroupID(admissionData.fee_group_id);
  }, [admissionData.vendor_id, admissionData.branch_id, isSuperAdmin, isAdmin]);

  useEffect(() => {
    // if (!location.state) {
    //   GetLastAdmissionNo(); // only in add mode
    // }
    //GetFee_GroupData();
    Get_All_Multi_Purpose_Type_Master();
    // fetchClasses();
    getTransport('');
  }, [SlabMasterTotalMont]);

  useEffect(() => {
    GetSlabMasterByFeeGroupID();
  }, [admissionData.fee_group_id, admissionData.curr_class_id, admissionData.session_year]);

  const [errorMessage, setErrorMessage] = useState('');

  const GetMonthlyFeeStructure = () => {
    const filterDate = SlabMaster.find(
      (s) => s.id === parseInt(location.state?.slabMstId),
    );
    // console.log(SlabMaster, 'SlabMaster');
    // console.log(location.state, 'location.state');
    // console.log(location.state?.slabMstId, 'location.state?.slabMstId');
    // console.log(filterDate, 'SlabMasterTotalMont');
    if (filterDate) {
      setSlabMasterTotalMont(filterDate);
    }
  };

  const onHandleBackParty = () => {
    navigate('/Admission');
  };
  // Example usage:

  const GetFee_GroupData = async () => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/FeeGroupMaster/GetFeeGroup?vendorId=${admissionData.vendor_id}&branchId=${admissionData.branch_id}`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        setFee_Group_data(response.data);
        // setTotalPage(response.totalPages);
      } else {
        console.log(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error('SomeThing went wrong!!');
    }
  };

  const optionsGender = [
    { label: 'Select', value: 'Select' },
    { label: 'Male', value: 'MALE' },
    { label: 'Female', value: 'FEMALE' },
    { label: 'Other', value: 'OTHER' },
  ];
  const optionsTcIssue = [
    { label: 'Select', value: 'Select' },
    { label: 'Yes', value: 'YES' },
    { label: 'No', value: 'NO' },
  ];
  const optionsAcClose = [
    { label: 'Select', value: 'Select' },
    { label: 'Yes', value: 'YES' },
    { label: 'No', value: 'NO' },
  ];

  const sessionYears = [
    { label: '2022-23', value: '2022-23' },
    { label: '2023-24', value: '2023-24' },
    { label: '2024-25', value: '2024-25' },
  ];

  // const MotherTongueList = [
  //   { label: 'Select', value: 'Select' },
  //   { label: 'Hindi', value: 'Hindi' },
  //   { label: 'English', value: 'English' },
  //   { label: 'Tamil', value: 'Tamil' },
  //   { label: 'Urdu', value: 'Urdu' },
  // ];

  // const catogeryList = [
  //   { label: 'Select', value: 'Select' },
  //   { label: 'GEN', value: 'GEN' },
  //   { label: 'OBC', value: 'OBC' },
  //   { label: 'ST', value: 'ST' },
  //   { label: 'SC', value: 'SC' },
  // ];
  const ConveyanceList = [
    { label: 'Select', value: 'Select' },
    { label: 'Yes', value: 'YES' },
    { label: 'No', value: 'NO' },
  ];

  // const religionList = [
  //   { label: 'Select', value: 'Select' },
  //   { label: 'Hinduism', value: 'Hinduism' },
  //   { label: 'Islam', value: 'Islam' },
  //   { label: 'Jainism', value: 'Jainism' },
  //   { label: 'Buddhism', value: 'Buddhism' },
  //   { label: 'Sikhism', value: 'Sikhism' },
  //   { label: 'Zoroastrianism', value: 'Zoroastrianism' },
  //   { label: 'Other', value: 'Other' },
  // ];

  const onChangeHandle = (e) => {
    const { name, value, files } = e.target;
    if (name === 'student_pic') {
      setAdmissionData((prevData) => ({
        ...prevData,
        [name]: files[0],
      }));
    }
    // if (name === 'cov_yn') {
    //   if (value === 'Yes') {
    //     setconyn_detail('');
    //   } else {
    //     setconyn_detail('none');
    //   }
    // }

    // if(name === "curr_class_id")
    // {
    //   GetSlabMasterByFeeGroupID(value);
    // }

    if (name === 'transport_id') {
      //debugger;
      const singleData = transportList.filter((s) => s.id === value);
      if (singleData && singleData.length > 0) {
        if (singleData[0].car_name !== '') {
          singleData[0].car_name1 = singleData[0].car_name
            .split(', ')
            .map((profile) => ({
              value: profile,
              label: profile,
            }));
        }
        setTransportData(
          singleData[0] || {
            id: 0,
            driver_name: '',
            address: '',
            phone_no: '',
            vehicle_no: '',
            car_name: '',
            driving_licence_no: '',
            aadhar_card_no: '',
          },
        );
      }
    }

    // if (name === 'fee_group_id') {
    //   GetSlabMasterByFeeGroupID(value);
    //   //setSlabMasterTotalMont({});
    // }
    if (name === 'slabMstId') {
      toast.info("If you are changing slabs, you have to generating fees installments manually")
      const filterDate = SlabMaster.find((s) => s.id === parseInt(value));
      if (filterDate) {
        setSlabMasterTotalMont(filterDate);
      }
      //console.log(filterDate,"filterDate");
    }
    setAdmissionData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrorMessage((prevErrors) => ({
      ...prevErrors,
      [name]: '', // Clear the previous error when the user starts typing
    }));
  };

  // const receiveDataFromChild = (data) => {
  //
  //   setAdmissionData(data);
  // };

  const validateInputs = () => {
    const errors = {};
    if (!admissionData.curr_class_id || Number(admissionData.curr_class_id) <= 0) {
      errors.curr_class_id = 'Class Name is required';
    }

    if (!admissionData.stud_name) {
      errors.stud_name = 'Student Name is required';
    }
    if (!admissionData.stud_ph_no) {
      errors.stud_ph_no = 'Phone Number is required';
    } else if (!/^[6-9]\d{9}$/.test(admissionData.stud_ph_no)) {
      errors.stud_ph_no = 'Enter a valid 10-digit phone number';
    }

    if (isSuperAdmin) {
      if (!admissionData.vendor_id || Number(admissionData.vendor_id) <= 0) {
        toast.error('Please select a Vendor');
        return false;
      }
    }

    // Admin OR multi-branch user → must select branch
    if (isSuperAdmin || isAdmin || hasMultiBranch) {
      // Validate Semester (must be a number > 0)
      if (!admissionData.branch_id || Number(admissionData.branch_id) <= 0) {
        toast.error('Please select a Branch');
        return false;
      }
    }

    // if (!admissionData.circle_name_description) {
    //   errors.circle_name_description = 'Party Address is required';
    // }

    return errors;
  };

  const validateInputs1 = () => {
    const errors = {};
    if (!Multi_Purpose_Type_MasterData.multi_purpose_type) {
      errors.multi_purpose_type = 'multi_purpose_type is required';
    }

    return errors;
  };

  const togglePopup = () => {
    setPopupVisible(false);
  };

  const GetSlabMasterByFeeGroupID = async () => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      //console.log( 'curr_class_id', admissionData.curr_class_id);
      const response = await apiService.get(
        `api/SlabMaster/GetSlabMasterByFeeGroupID?fee_group_id=${admissionData.fee_group_id}&session=${sessionData.session_year}&class_id=${admissionData.curr_class_id}`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        // console.log(response,"response fee slab")
        setSlabMaster(response.slab_Master_List);
        const filterDate = response.slab_Master_List.find(
          (s) => s.id === parseInt(location.state?.slabMstId),
        );
        if (filterDate) {
          setSlabMasterTotalMont(filterDate);
        }
        GetMonthlyFeeStructure();   //slab monthly fee data

        //updateHeaderData();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error('SomeThing went wrong!!');
    }
  };

  const fetchClasses = async (searchText = '') => {
    try {
      const vendorId = admissionData.vendor_id || '';
      const branchId = admissionData.branch_id || '';

      const response = await apiService.get(
        `api/ClassMaster/GetClassMaster?vendorId=${vendorId}&branchId=${branchId}&searchItem=${encodeURIComponent(
          searchText || '',
        )}`,
      );

      // setClass_MasterData(response.item1);
      setClass_AdmitData(response.data);
      // setClass_SectionData(response.item3);
    } catch (error) {
      console.log(error);
      toast.error('SomeThing went wrong!!');
    }
  };
  const Get_All_Multi_Purpose_Type_Master = async () => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };
      const response = await apiService.get(
        `api/Multi_Purpose_Type_Master/Get_All_Multi_Purpose_Type_Master`,
        config,
      );
      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }
      if (response.status === true) {
        ////
        setMultiPurposeMaster(response.data);

        setReligionList(
          response.data.filter(
            (item) => item.multi_purpose_flag === 'Religion',
          ),
        );
        setCategoryList(
          response.data.filter(
            (item) => item.multi_purpose_flag === 'Category_Financial',
          ),
        );
        setMotherTongueList(
          response.data.filter(
            (item) => item.multi_purpose_flag === 'MotherTongue',
          ),
        );
        setBankList(
          response.data.filter((item) => item.multi_purpose_flag === 'Bank'),
        );
        setQualificationList(
          response.data.filter(
            (item) => item.multi_purpose_flag === 'Qualification',
          ),
        );
        setProfList(
          response.data.filter(
            (item) => item.multi_purpose_flag === 'Profession',
          ),
        );
        //debugger;
        const carOption = response.data
          .filter((item) => {
            return item.multi_purpose_flag === 'CarName';
          })
          .map((profile) => ({
            value: profile.multi_purpose_type,
            label: profile.multi_purpose_type,
          }));
        setcarOptions(carOption);
        //updateHeaderData();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error('SomeThing went wrong!!');
    }
  };

  const GetLastAdmissionNo = async () => {
    ////
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };
      const response = await apiService.get(
        `api/Admission/GetLastAdmissionNo?vendorId=${admissionData.vendor_id}&branchId=${admissionData.branch_id}`,
        config,
      );

      setAdmissinNum(response.message);
      setAdmissionData((prevData) => ({
        ...prevData,
        admit_no: response.message,
      }));
    } catch (error) {
      console.log(error);
      toast.error('SomeThing went wrong!!');
    }
  };

  const onHandleMultipleValue = (param) => {
    // setPopupVisible(true);
    setModal(!modal);
    setMulti_Purpose_Type_MasterData((prevData) => ({
      ...prevData,
      multi_purpose_flag: param,
    }));
    //console.log(admissionData);
    // navigate('/save_multi_purpose_master', {
    //   state: { admissionData: admissionData, type: param },
    // });
  };

  const getTransport = async (search, transport_id) => {
    //debugger;
    if (search === null) {
      search = '';
    }
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file uploads
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/Transport/GetTransport?search=${search}`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }

      if (response.status === true) {
        setTransportList(response.data);
        //debugger;

        const singleData = response.data?.filter((s) => s.id === transport_id);
        if (singleData && singleData.length > 0) {
          if (singleData[0].car_name !== '') {
            singleData[0].car_name1 = singleData[0].car_name
              .split(', ')
              .map((profile) => ({
                value: profile,
                label: profile,
              }));
          }
          setTransportData(
            singleData[0] || {
              id: 0,
              driver_name: '',
              address: '',
              phone_no: '',
              vehicle_no: '',
              car_name: '',
              driving_licence_no: '',
              aadhar_card_no: '',
            },
          );
        }
        // setTotalPage(response.totalPages);
      }
    } catch (error) {
      console.log(error);
      toast.error('SomeThing went wrong!!');
    }
  };
  const onClickSetValue = () => {
    setAdmissionData((prevData) => ({
      ...prevData,

      adm_sch_id: 0,
      session_year: sessionData.session_year,

      stud_name: 'Demo',
      sex_mf: 'male',
      d_o_b: new Date().toISOString().split('T')[0],
      adm_date: sessionData.defaultDate, // Set current date
      class_admit: 'Demo',
      curr_class: 'Demo',
      curr_sec: 'Demo',
      roll_no: 'Demo',
      barcode_no: 'Demo',
      ac_close_yn: 'Demo',
      ac_close_date: new Date('Sat Jul 19 1990 14:00:00 GMT+0200')
        .toISOString()
        .substr(0, 10),
      tc_issue_yn: 'Demo',
      tc_issue_date: new Date('Sat Jul 19 1990 14:00:00 GMT+0200')
        .toISOString()
        .substr(0, 10),
      sadd1: 'Demo',
      sadd2: 'Demo',
      sadd3: 'Demo',
      state_name: 'Demo',
      pin_code: 'Demo',
      alt_add: 'Demo',
      living_dur: 'Demo',
      category_class: 'Demo',
      religion_name: 'Demo',
      mother_tong: 'Demo',
      addhar_no: 'Demo',
      bank_name: 'Demo',
      bank_ac_no: 'Demo',
      cov_yn: '',
      con_det: 'Demo',
      fee_group_id: 0,
      slab_code: 0,
      slabMstId: 0,
      fee_flag_type: 0,
      tot_fees: 0,
      op_bal: 0,
      douc_list_det: 'Demo',
      f_name: 'Demo',
      m_name: 'Demo',
      g_name: 'Demo',
      f_quali: 'Demo',
      m_quali: 'Demo',
      g_quali: 'Demo',
      f_prof: 'Demo',
      m_prof: 'Demo',
      g_prof: 'Demo',
      f_income: 'Demo',
      m_income: 'Demo',
      g_income: 'Demo',
      f_officeph: 'Demo',
      m_officeph: 'Demo',
      g_officeph: 'Demo',
      f_mob: 'Demo',
      m_mob: 'Demo',
      g_mob: 'Demo',
      //entering_date_time: null,
      last_sch_name: 'Demo',
      last_sch_add: 'Demo',
      last_sch_city: 'Demo',
      last_sch_state: 'Demo',
      last_sch_pincode: 'Demo',
      last_sch_adm_no: 'Demo',
      mark_obtain: 0,
      max_marks: 0,
      last_marks_per: 0,
      sibling_adm_no_1: 'Demo',
      sibling_class_1: 'Demo',
      sibling_name_1: 'Demo',
      sibling_adm_no_2: 'Demo',
      sibling_class_2: 'Demo',
      sibling_name_2: 'Demo',
      sys_remark: 'Demo',
      // samp: 'test ',
      //  student_pic: ''
    }));
  };

  const AddAdmission = async () => {
    try {
      const errors = validateInputs();
      if (Object.keys(errors).length > 0) {
        setErrorMessage(errors);
        return;
      }

      const formData = new FormData();
      formData.append('student_pic', selectedFile);

      // Convert userData to JSON
      //formData.append("samp", JSON.stringify(admissionData));

      // Append each field from userData
      Object.entries(admissionData).forEach(([key, value]) => {
        if (value === null || value === undefined) {
          formData.append(key, '');
        } else {
          formData.append(key, value);
        }
      });
      // console.log([...formData.entries()]);

      let config = {
        headers: {
          Accept: 'multipart/form-data',
          'Content-Type': 'multipart/form-data',
        },
      };

      let response;



      if (admissionData.id !== '0' && admissionData.id !== 0) {
        // const data = JSON.stringify(admissionData);
        response = await apiService.put(
          `api/Admission/UpdateAdmission?id=${admissionData.id}`,
          formData,
          config,
        );
      } else {
        //admissionData.admit_no = String(AdmissinNum);
        //const data = JSON.stringify(admissionData);

        response = await apiService.post(
          `api/Admission/AddAdmission`,
          formData,
          config,
        );
      }

      console.log(response);

      if (response.status === true) {
        toast.success(response.message);

        if (
          siblingTransection.length > 0 &&
          siblingTransection[0].adm_no !== ''
        ) {
          AddSibling(response.id, false);
        } else {
          navigate('/Admission');
        }
        // Redirect to desired page after successful submission
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error('SomeThing went wrong!!');
    }
  };


  const AddSibling = async (adm_id, value) => {
    try {
      let config = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      //
      let response;
      if (value) {
        const data = JSON.stringify(siblingTransection);
        response = await apiService.put(
          `api/SiblingDetails/UpdateSiblingDetail?adm_id=${adm_id}`,
          data,
          config,
        );
      } else {
        const data = JSON.stringify(siblingTransection);
        response = await apiService.post(
          `api/SiblingDetails/AddSiblingDetails?adm_id=${adm_id}`,
          data,
          config,
        );
      }

      if (response.status === true) {
        console.log(response.message);
        // Redirect to desired page after successful submission
        navigate('/Admission');
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error('SomeThing went wrong!!');
    }
  };
  const save_multi_purpose_master = async () => {
    try {
      const errors = validateInputs1();
      if (Object.keys(errors).length > 0) {
        setErrorMessage(errors);
        return;
      }

      let config = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };
      const data = JSON.stringify(Multi_Purpose_Type_MasterData);

      //
      let response;

      if (
        Multi_Purpose_Type_MasterData.id === '0' ||
        Multi_Purpose_Type_MasterData.id === 0
      ) {
        response = await apiService.put(
          `api/Multi_Purpose_Type_Master/UpdateMulti_Purpose_Type_Master?id=${Multi_Purpose_Type_MasterData.id}`,
          data,
          config,
        );
      } else {
        response = await apiService.post(
          'api/Multi_Purpose_Type_Master/AddMulti_Purpose_Type_Master',
          data,
          config,
        );
      }
      if (response.status === true) {
        toast.success(response.message);
        setModal(!modal);
        setMulti_Purpose_Type_MasterData({
          multi_purpose_flag: '',
          multi_purpose_code: '',
          multi_purpose_type: '',
          multi_purpose_remark: '',
        });
        Get_All_Multi_Purpose_Type_Master();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error);
      alert('Something went wrong"');
    }
  };

  const onChangeHandle1 = (e) => {
    const { name, value } = e.target;
    setMulti_Purpose_Type_MasterData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrorMessage((prevErrors) => ({
      ...prevErrors,
      [name]: '', // Clear the previous error when the user starts typing
    }));
  };

  const addSiblingTData = () => {
    GetSingleAdmissionRecord(siblingAdmid);
  };

  const deleteSiblingTData = (index, id) => {
    //if (id === undefined) {
    const updatedRows = siblingTransection.filter((_, i) => i !== index);
    setSiblingTransection(updatedRows);
    //} else {
    //deleteSiblingOnServer(id);
    //}
  };
  const deleteSiblingOnServer = async (id) => {
    const isDeleteConfirmed = window.confirm(
      'Are you sure you want to delete this item?',
    );
    if (isDeleteConfirmed) {
      try {
        let config = {
          headers: {
            'Content-Type': 'application/json', // Important for file uploads
            accept: 'application/json',
          },
        };

        const response = await apiService.delete(
          `api/SiblingDetails/DeleteSiblingDetail?id=${id}`,
          config,
        );
        if (response.response && response.response.data.errors) {
          toast.error(response.response?.data?.errors);
        }

        if (response.status === true) {
          toast.success(response.message);
          GetSiblingDetailtById(admissinid);
        } else {
          toast.success(response.message);
        }
      } catch (error) {
        console.log(error);
        toast.error('SomeThing went wrong!!');
      }
    } else {
      console.log('Deletion canceled.');
    }
  };
  const handleInputChange = (e) => {
    setSiblingAdmId(e.target.value);
  };

  const GetSingleAdmissionRecord = async (search = '') => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const apiUrl = `api/Admission/GetSingleAdmissionRecord?search=${search}`;

      const response = await apiService.get(apiUrl, config);

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
      }
      console.log(response);

      if (response.status === true) {
        let respData = response.admissionDetail;
        if (response.admissionDetail !== null) {
          const newSibling = {
            adm_id: admissionData.id,
            sibling_Name: respData.stud_name,
            adm_no: respData.admit_no,
            sibling_class: respData.curr_class,
            adm_date: respData.adm_date,
            roll_no: respData.roll_no,
          };
          setSiblingTransection([...siblingTransection, newSibling]);
        }
      } else {
        toast.error('No student found for this admission number');
      }
    } catch (error) {
      console.log(error);
      toast.error('SomeThing went wrong!!');
    }
  };

  const onHandleDeleteAdmission = async () => {
    const isDeleteConfirmed = window.confirm(
      'Are you sure you want to delete this item?',
    );
    if (isDeleteConfirmed) {
      try {
        let config = {
          headers: {
            'Content-Type': 'application/json', // Important for file upload//s
            accept: 'application/json',
          },
        };

        const response = await apiService.delete(
          `api/Admission/DeleteAdmission?id=${location.state?.id}`,
          config,
        );
        if (response.response && response.response.data.errors) {
          toast.error(response.response?.data?.errors);
        }

        if (response.status === true) {
          toast.success(response.message);
          navigate('/Admission');
        } else {
          toast.success(response.message);
        }
      } catch (error) {
        console.log(error);
        toast.error('SomeThing went wrong!!');
      }
    } else {
      console.log('Deletion canceled.');
    }
  };

  const handlePrint = async () => {
    const blob = await pdf(
      <FeeCardPDF
        systemData={systemData}
        studentData={admissionData}
        sessionData={sessionData}
        monthlyFees={SlabMasterTotalMont}
        enrollmentData={admissionResp}
      />,
    ).toBlob();
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  };

  const fieldMap = [
    { key: 'school_name', gx: 700, gy: 680 },
    { key: 'batchTiming', gx: 700, gy: 660 },
    { key: 'counsellorName', gx: 720, gy: 640 },

    { key: 'd_o_b', gx: 705, gy: 583 },
    { key: 'dateOfAdmission', gx: 855, gy: 583 },
    { key: 'regnFee', gx: 700, gy: 560 },
    { key: 'monthly', gx: 700, gy: 541 },
    { key: 'annually', gx: 700, gy: 519 },
    { key: 'halfYearly', gx: 700, gy: 498 },
    { key: 'quarterly', gx: 700, gy: 477 },
    { key: 'totalCourseFee', gx: 870, gy: 560 },
    { key: 'doj', gx: 820, gy: 545 },
    { key: 'doe', gx: 820, gy: 532 },
    { key: 'dt1', gx: 810, gy: 517 },
    { key: 'dt2', gx: 813, gy: 498 },
    { key: 'dt3', gx: 813, gy: 477 },
    { key: 'dt4', gx: 805, gy: 455 },

    { key: 'doc10Marksheet', gx: 1100, gy: 580 },
    { key: 'doc10Certificate', gx: 1100, gy: 560 },
    { key: 'doc12Marksheet', gx: 1100, gy: 540 },
    { key: 'doc12Certificate', gx: 1100, gy: 520 },
    { key: 'graduationDegree', gx: 1100, gy: 500 },
    { key: 'migrationCertificate', gx: 1100, gy: 480 },
    { key: 'aadharCard', gx: 1100, gy: 460 },
    { key: 'photographs', gx: 1100, gy: 440 },

    { key: 'stud_name', gx: 740, gy: 398 },
    { key: 'admissionCourse', gx: 1005, gy: 398 },
    { key: 'admissionMonthYear', gx: 1000, gy: 376 },
    { key: 'stud_name', gx: 800, gy: 355 },
    { key: 'sex_mf', gx: 1080, gy: 355 },

    { key: 'maritalStatus', gx: 800, gy: 333 },
    { key: 'religion_name', gx: 970, gy: 333 },
    { key: 'category_class', gx: 1080, gy: 333 },

    { key: 'f_name', gx: 750, gy: 311 },
    { key: 'f_mob', gx: 1030, gy: 311 },

    { key: 'f_prof', gx: 780, gy: 289 },
    { key: 'm_name', gx: 740, gy: 267 },
    { key: 'sadd1', gx: 800, gy: 245 },
    { key: 'constituency', gx: 800, gy: 225 },
    { key: 'sadd1', gx: 760, gy: 203 },
    { key: 'mobile', gx: 720, gy: 181 },
    { key: 'email', gx: 960, gy: 181 },
    { key: 'academicQualification', gx: 770, gy: 159 },
    { key: 'professionalQualification', gx: 760, gy: 137 },

    { key: 'lastExamPassed', gx: 730, gy: 115 },
    { key: 'lastExamYear', gx: 830, gy: 115 },
    { key: 'lastExamStream', gx: 930, gy: 115 },
    { key: 'lastExamPercentage', gx: 1080, gy: 115 },
  ];

  const fillPdf = async (data) => {
    const wholeData = {
      ...systemData,
      ...data,
      ...admissionData,
      d_o_b: formatDate(admissionData.d_o_b),
    };
    const existingPdfBytes = await fetch(
      '/assets/school_files/admissionForm.pdf',
    ).then((r) => r.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const page = pdfDoc.getPages()[0];
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

    fieldMap.forEach((f) => {
      //const { x, y } = convert(f.gx, f.gy);
      const x = f.gx;
      const y = f.gy;
      page.drawText(wholeData[f.key] ?? '', {
        x,
        y,
        size: 10,
        font,
        color: rgb(0, 0, 0),
      });
    });

    // 2. Load an image (PNG or JPG)
    let jpgImage = null;

    if (location.state?.stud_img_path) {
      try {
        const imageUrl =
          process.env.REACT_APP_API_BASE_URL + location.state.stud_img_path;

        const res = await fetch(imageUrl);

        // image not found (404 / 500)
        if (!res.ok) throw new Error('Image not found');

        const contentType = res.headers.get('content-type');

        // ensure it's a jpeg
        if (!contentType || !contentType.includes('image/jpeg')) {
          throw new Error('Not a JPEG image');
        }

        const imageBytes = await res.arrayBuffer();

        // empty / corrupted file
        if (!imageBytes || imageBytes.byteLength === 0) {
          throw new Error('Empty image file');
        }

        jpgImage = await pdfDoc.embedJpg(imageBytes);

        // 6. Draw image
        page.drawImage(jpgImage, {
          x: 1030,
          y: 630,
          width: 110,
          height: 120,
        });
      } catch (err) {
        console.warn('Student image skipped:', err.message);
        jpgImage = null; // continue without image
      }
    }

    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  };

  const sampleData = {
    // Top – Centre Details
    centreName: 'Janakpuri Branch',
    batchTiming: '10:00 AM - 12:00 PM',
    counsellorName: 'Ms. Ritu Sharma',

    // Admission Form Top Box
    dateOfBirth: '07-04-2005',
    dateOfAdmission: '15-11-2025',
    regnFee: '1000',
    monthly: '2500',
    annually: '30000',
    halfYearly: '15000',
    quarterly: '7500',
    totalCourseFee: '32000',
    doj: '20-11-2025',
    doe: '20-11-2026',
    dt1: '01-12-2025',
    dt2: '01-01-2026',
    dt3: '01-02-2026',
    dt4: '01-03-2026',

    // Documents Attached (✓ or blank)
    doc10Marksheet: 'Submitted',
    doc10Certificate: 'Submitted',
    doc12Marksheet: 'Submitted',
    doc12Certificate: 'Submitted',
    graduationDegree: 'Submitted',
    migrationCertificate: 'Submitted',
    aadharCard: 'Submitted',
    photographs: 'Submitted',

    // Main Body
    confirmStatement: 'I, Arshi Mansoori',
    admissionCourse: 'Fashion Designing',
    admissionMonthYear: 'Nov 2025',

    studentName: 'ARSHI MANSOORI',
    gender: 'Female',

    maritalStatus: 'Single',
    religion: 'Islam',
    category: 'General',

    fatherName: 'Mohd. Mansoori',
    fatherMobile: '9876543210',
    profession: 'Private Job',

    motherName: 'Nafisa Mansoori',

    permanentAddress: 'D-14, Gali No. 2, Shastri Park, Delhi - 110053',
    constituency: 'Delhi North-East',
    correspondenceAddress: 'Same as permanent address',

    mobile: '9876543210',
    email: 'arshi.mansoori@example.com',

    academicQualification: '12th Pass',
    professionalQualification: 'N/A',

    lastExamPassed: '12th',
    lastExamYear: '2021',
    lastExamStream: 'Arts',
    lastExamPercentage: '78%',
  };

    const generateInstallments = async () => {
      try {
        const response = await apiService.get(
          `api/Enrollment/GenerateInstallments?enrollmentId=${admissionResp.singleEnrollmentRecord.enrollment_id}&installmentType=monthly`,
        );
  
        if (response.response && response.response.data?.errors) {
          toast.error(response.response.data.errors);
        }
  
        if (response.status === true) {
          toast.success("Installment generated successfully")
          //setInstallmentList(response.studentFeeInstallments);
        } else {
          toast.error(response.message || 'Failed to fetch');
        }
      } catch (error) {
        console.error(error);
        toast.error('SomeThing went wrong');
      }
    };

  return (
    <>
      <div className='bg-white pd-5 card-box mb-5 toolbar-row sticky-top border text-right mb-2'>
        <Button color='danger' onClick={onHandleDeleteAdmission}>
          <i className='bi bi-trash' /> Delete
        </Button>{' '}
        &nbsp;
        {isUpdate && (
          <>
            &nbsp;
            {/* iwp academy print form */}
            {/* <button
              className='btn btn-info'
              onClick={() => fillPdf(sampleData)}
            >
              <i className='bi bi-printer' /> Print Adm. Form
            </button> */}
            <BlobProvider
              document={<AdmissionFormPDF data={admissionData} systemData={systemData} siblingsData={siblingTransection} session={sessionData.session_year} />}
            >
              {({ url }) => {

                return (
                  <button
                    className="btn btn-info"
                    onClick={() => {
                      if (url) {
                        // Open the PDF in a new tab
                        window.open(url, '_blank');
                      }
                    }}
                  >
                    <i className="bi bi-printer" /> Print Adm. Form
                  </button>
                );
              }}
            </BlobProvider>
            &nbsp;

            <button
              className="btn btn-primary"
              onClick={handlePrint}
            >
              <i className="bi bi-printer" /> Print Fee Card
            </button>
          </>
        )}
        &nbsp;
        <Button className='mr-2' color='success' onClick={AddAdmission}>
          Save Details <i className='bi bi-check-circle ml-2'></i>
        </Button>
        &nbsp;
        <Button color='warning' onClick={onHandleBackParty}>
          <i className='bi bi-arrow-left' /> Back
        </Button>
      </div>

      <h4 className='text-capitalize'>Student Admission Form</h4>
      <p className='text-content mb-5'>
        Please fill out the details below for saving the admission form
      </p>
      {/* <nav className="" aria-label="breadcrumb">
    <ol className="breadcrumb">
      <a className="text-decoration-none breadcrumb-item" href="/">
        Home
      </a>
      <li className="active breadcrumb-item" aria-current="page">
        form-layout
      </li>
      <li className="active breadcrumb-item" aria-current="page">
        form-basic
      </li>
    </ol>
  </nav> */}

      <VendorBranchSelector
        user={user}
        selectionData={admissionData}
        setSelectionData={setAdmissionData}
        errorMessage={errorMessage}
        accessButton={true}
      />

      <Card className='card-box height-100-p pd-20 mb-20'>
        <CardTitle
          onClick={() => toggleCollapse('studentDetails')}
          style={{ cursor: 'pointer', backgroundColor: '#d3edfa' }}
          tag='h6'
          className='p-3 mb-0 d-flex align-items-center justify-content-between'
        >
          <div className='d-flex align-items-center'>
            <i className='bi bi-person-fill mr-2'></i> Student Details
          </div>
          {/* Arrow icon that toggles between up and down */}
          <i
            className={`bi ${openCards.studentDetails ? 'bi-chevron-up' : 'bi-chevron-down'
              }`}
          ></i>
        </CardTitle>
        <CardBody
          id='studentDetailsColl'
          className={`accordion-collapse collapse ${openCards.studentDetails ? 'show' : ''
            }`}
        >
          <div className='row'>
            {/* <div className='col-sm-3'>
              <FormGroup>
                <Label for='registration_no'>Registration no</Label>
                <Input
                  id='registration_no'
                  name='registration_no'
                  value={admissionData.registration_no}
                  onChange={onChangeHandle}
                  type='text'
                />
                {errorMessage.registration_no && (
                  <FormText color='danger'>
                    {errorMessage.registration_no}
                  </FormText>
                )}
              </FormGroup>
            </div>
            <div className='col-sm-3'>
              <FormGroup>
                <Label for='roll_no'>Roll no</Label>
                <Input
                  id='roll_no'
                  name='roll_no'
                  value={admissionData.roll_no}
                  onChange={onChangeHandle}
                  type='text'
                />
                {errorMessage.roll_no && (
                  <FormText color='danger'>{errorMessage.roll_no}</FormText>
                )}
              </FormGroup>
            </div> */}
            <div className='col-sm-6'>
              <FormGroup>
                <Label for='stud_name'>Student Name</Label>
                <Input
                  id='stud_name'
                  name='stud_name'
                  value={admissionData.stud_name}
                  onChange={onChangeHandle}
                  type='text'
                />
                {errorMessage.stud_name && (
                  <FormText color='danger'>{errorMessage.stud_name}</FormText>
                )}
              </FormGroup>
            </div>
            <div className='col-sm-6 text-right text-primary'>
              <FormGroup>
                <Label className='mb-1'>Current Class : {admissionResp?.enrollmentData?.[0]?.course_name} </Label>
                {/* <Select
                  options={sessionOptions}
                  value={
                    sessionOptions.find(
                      (o) => 
                        String(o.value) ===
                        sessionData.session_year,
                    ) || null
                  }
                  onChange={onChangeHandle}
                  onInputChange={(val, meta) => {
                    if (meta.action === 'input-change') fetchSessions(val);
                  }}
                  isClearable
                  isSearchable
                  placeholder='Type and Choose a Session...'
                />
                {errorMessage.session_year && (
                  <FormText color='danger'>
                    {errorMessage.session_year}
                  </FormText>
                )} */}
              </FormGroup>
            </div>
          </div>

          <div className='row'>
            <div className='col-sm-9'>
              <div className='row'>
                <div className='col-sm-4'>
                  <FormGroup>
                    <Label for='admit_no'>Admission No.</Label>
                    {/* 
                        {!isUpdate ? (
                          <Input
                            id='admit_no'
                            name='admit_no'
                            value={AdmissinNum}
                            onChange={onChangeHandle}
                            type='text'
                          />
                        ) : ( */}
                    <Input
                      id='admit_no'
                      name='admit_no'
                      value={admissionData.admit_no}
                      onChange={onChangeHandle}
                      type='text'
                    />
                    {/* )} */}
                    {errorMessage.admit_no && (
                      <FormText color='danger'>
                        {errorMessage.admit_no}
                      </FormText>
                    )}
                  </FormGroup>
                </div>
                <div className='col-sm-4'>
                  <FormGroup>
                    <Label for='adm_date'>Admission Date</Label>
                    <Input
                      id='adm_date'
                      name='adm_date'
                      min={sessionData.session_start_date}
                      max={sessionData.session_end_date}
                      value={formatDate(admissionData.adm_date, 'YYYY-MM-DD')}
                      onChange={onChangeHandle}
                      type='date'
                    />
                    {errorMessage.adm_date && (
                      <FormText color='danger'>
                        {errorMessage.adm_date}
                      </FormText>
                    )}
                  </FormGroup>
                </div>

                <div className='col-sm-4'>
                  <FormGroup>
                    <Label for='d_o_b'>Date of Birth</Label>
                    <Input
                      id='d_o_b'
                      name='d_o_b'
                      value={formatDate(admissionData.d_o_b, 'YYYY-MM-DD')}
                      onChange={onChangeHandle}
                      type='date'
                    />
                    {errorMessage.d_o_b && (
                      <FormText color='danger'>{errorMessage.d_o_b}</FormText>
                    )}
                  </FormGroup>
                </div>
                <div className='col-sm-8'>
                  <FormGroup>
                    <Label for='curr_class_id'>Class/Course</Label>
                    <select
                      className='custom-select'
                      id='curr_class_id'
                      name='curr_class_id'
                      value={admissionData.curr_class_id}
                      onChange={onChangeHandle}
                    >
                      <option value='0'>-Select-</option>
                      {class_AdmitData.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.class_Name}
                        </option>
                      ))}
                    </select>
                    {errorMessage.curr_class_id && (
                      <FormText color='danger'>{errorMessage.curr_class_id}</FormText>
                    )}
                  </FormGroup>
                </div>

                <div className='col-sm-4'>
                  <FormGroup>
                    <Label for='sex_mf'>Gender</Label>
                    <select
                      className='custom-select'
                      id='sex_mf'
                      name='sex_mf'
                      value={admissionData.sex_mf}
                      onChange={onChangeHandle}
                    >
                      {optionsGender.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>

                    {errorMessage.sex_mf && (
                      <FormText color='danger'>{errorMessage.sex_mf}</FormText>
                    )}
                  </FormGroup>
                </div>
              </div>
            </div>
            <div className='col-sm-3 d-flex flex-column align-items-center'>
              {/* Image Preview Box */}
              <div
                style={{
                  width: '13vh',
                  height: '15vh',
                  border: '1px solid #ccc',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {previewImage ? (
                  <img
                    src={previewImage}
                    alt='Student Picture'
                    style={{ maxWidth: '100%', maxHeight: '100%' }}
                  />
                ) : (
                  <span>No image uploaded</span>
                )}
              </div>

              {/* Input */}
              <FormGroup className='mt-2 w-100 text-center'>
                <Label for='student_pic'>Student Picture</Label>
                <Input
                  id='student_pic'
                  name='student_pic'
                  type='file'
                  onChange={handleFileChange}
                />
              </FormGroup>
            </div>
          </div>

          {/* <div className='col-sm-3'>
                          <FormGroup>
                            <Label for='stud_name'>Last Name</Label>
                            <Input
                              id='stud_name'
                              name='stud_name'
                              value={admissionData.stud_name}
                              onChange={onChangeHandle}
                              type='stud_name'
                            />
                            {errorMessage.stud_name && (
                              <FormText color='danger'>
                                {errorMessage.stud_name}
                              </FormText>
                            )}
                          </FormGroup>
                        </div> */}

          <div className='row'>
            <div className='col-sm-6'>
              <FormGroup>
                <Label for='stud_ph_no'>Student's Mobile Number</Label>
                <Input
                  id='stud_ph_no'
                  name='stud_ph_no'
                  value={admissionData.stud_ph_no}
                  onChange={onChangeHandle}
                  type='text'
                />
                {errorMessage.stud_ph_no && (
                  <FormText color='danger'>{errorMessage.stud_ph_no}</FormText>
                )}
              </FormGroup>
            </div>
            <div className='col-sm-6'>
              <FormGroup>
                <Label for='stud_email'>Student's Email address</Label>
                <Input
                  id='stud_email'
                  name='stud_email'
                  value={admissionData.stud_email}
                  onChange={onChangeHandle}
                  type='text'
                />
                {errorMessage.stud_email && (
                  <FormText color='danger'>{errorMessage.stud_email}</FormText>
                )}
              </FormGroup>
            </div>
          </div>

          {/* <div className='row'>
        
                 <div className='col-sm-2'>

                  <FormGroup>
                    <Label for='curr_class'>Current Class</Label>
                    <select
                      className='custom-select'
                      id='curr_class'
                      name='curr_class'
                      value={admissionData.curr_class}
                      onChange={onChangeHandle}
                    >
                      <option value='0'>-Select-</option>
                      {class_AdmitData.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>

                    {errorMessage.curr_class && (
                      <FormText color='danger'>
                        {errorMessage.curr_class}
                      </FormText>
                    )}
                  </FormGroup>
                </div>
                <div className='col-sm-2'>

                  <FormGroup>
                    <Label for='curr_sec'>Current Section</Label>
                    <select
                      className='custom-select'
                      id='curr_sec'
                      name='curr_sec'
                      value={admissionData.curr_sec}
                      onChange={onChangeHandle}
                    >
                      <option value='0'>-Select-</option>
                      <option value='A'>A</option>
                      <option value='B'>B</option>
                      <option value='C'>C</option>
                      <option value='D'>D</option>
                      {class_SectionData.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </FormGroup>
                </div> 
                <div className='col-sm-3'>
                  <FormGroup>
                    <Label for='roll_no'>Class Roll No</Label>
                    <Input
                      id='roll_no'
                      name='roll_no'
                      value={admissionData.roll_no}
                      onChange={onChangeHandle}
                      type='text'
                    />
                    {errorMessage.roll_no && (
                      <FormText color='danger'>{errorMessage.roll_no}</FormText>
                    )}
                  </FormGroup>
                </div>
              </div>*/}

          <div className='row'>
            <div className='col-sm-4'>
              <FormGroup>
                <Label for='religion_name'>Religion</Label>

                <i
                  className='bi bi-question-circle float-right text-primary'
                  onClick={() => onHandleMultipleValue('Religion')}
                ></i>
                <select
                  className='custom-select'
                  id='religion_name'
                  name='religion_name'
                  value={admissionData.religion_name}
                  onChange={onChangeHandle}
                >
                  <option value='0'>Select Religion</option>
                  {religionList.map((option) => (
                    <option
                      key={option.multi_purpose_type}
                      value={option.multi_purpose_type}
                    >
                      {option.multi_purpose_type}
                    </option>
                  ))}
                </select>

                {errorMessage.name && (
                  <FormText color='danger'>
                    {errorMessage.religion_name}
                  </FormText>
                )}
              </FormGroup>
            </div>

            <div className='col-sm-4'>
              <FormGroup>
                <Label for='category_class'>
                  Adm Category (Gen,SC,ST,OBC,etc)
                </Label>
                <i
                  className='bi bi-question-circle float-right text-primary'
                  onClick={() => onHandleMultipleValue('Category_Financial')}
                ></i>
                <select
                  className='custom-select'
                  id='category_class'
                  name='category_class'
                  value={admissionData.category_class}
                  onChange={onChangeHandle}
                >
                  <option value='0'>-Select-</option>
                  {categoryList.map((option) => (
                    <option
                      key={option.multi_purpose_type}
                      value={option.multi_purpose_type}
                    >
                      {option.multi_purpose_type}
                    </option>
                  ))}
                </select>

                {errorMessage.category_class && (
                  <FormText color='danger'>
                    {errorMessage.category_class}
                  </FormText>
                )}
              </FormGroup>
            </div>

            <div className='col-sm-4'>
              <FormGroup>
                <Label for='mother_tong'>Mother Tongue</Label>

                <i
                  className='bi bi-question-circle float-right text-primary'
                  onClick={() => onHandleMultipleValue('MotherTongue')}
                ></i>
                <select
                  className='custom-select'
                  id='mother_tong'
                  name='mother_tong'
                  value={admissionData.mother_tong}
                  onChange={onChangeHandle}
                >
                  <option value='0'>Select Mother Tongue</option>
                  {motherTongueList.map((option) => (
                    <option
                      key={option.multi_purpose_type}
                      value={option.multi_purpose_type}
                    >
                      {option.multi_purpose_type}
                    </option>
                  ))}
                </select>
                {errorMessage.mother_tong && (
                  <FormText color='danger'>
                    {errorMessage.religion_name}
                  </FormText>
                )}
              </FormGroup>
            </div>
          </div>

          <div className='row'>
            <div className='col-sm-4'>
              <FormGroup>
                <Label for='addhar_no'>Aadhar No.</Label>
                <Input
                  id='addhar_no'
                  name='addhar_no'
                  value={admissionData.addhar_no}
                  onChange={onChangeHandle}
                  type='text'
                />
                {errorMessage.addhar_no && (
                  <FormText color='danger'>{errorMessage.addhar_no}</FormText>
                )}
              </FormGroup>
            </div>

            <div className='col-sm-4'>
              <FormGroup>
                <Label for='apaar_id'>APAAR ID</Label>
                <Input
                  id='apaar_id'
                  name='apaar_id'
                  value={admissionData.apaar_id}
                  onChange={onChangeHandle}
                  type='text'
                />
                {errorMessage.apaar_id && (
                  <FormText color='danger'>{errorMessage.apaar_id}</FormText>
                )}
              </FormGroup>
            </div>

            <div className='col-sm-4'>
              <FormGroup>
                <Label for='pen_id'>PEN ID</Label>
                <Input
                  id='pen_id'
                  name='pen_id'
                  value={admissionData.pen_id}
                  onChange={onChangeHandle}
                  type='text'
                />
                {errorMessage.pen_id && (
                  <FormText color='danger'>{errorMessage.pen_id}</FormText>
                )}
              </FormGroup>
            </div>
          </div>

          <div className='row'>
            <div className='col-sm-12'>
              <FormGroup>
                <Label for='sadd1'>Permanent Address</Label>
                <Input
                  id='sadd1'
                  name='sadd1'
                  value={admissionData.sadd1}
                  onChange={onChangeHandle}
                />
                {errorMessage.name && (
                  <FormText color='danger'>{errorMessage.sadd1}</FormText>
                )}
              </FormGroup>
            </div>

            <div className='col-sm-6'>
              <FormGroup>
                <Label for='sadd2'>Area/Location Name</Label>
                <Input
                  id='sadd2'
                  name='sadd2'
                  value={admissionData.sadd2}
                  onChange={onChangeHandle}
                  type='sadd2'
                />
                {errorMessage.sadd2 && (
                  <FormText color='danger'>{errorMessage.sadd2}</FormText>
                )}
              </FormGroup>
            </div>
            <div className='col-sm-6'>
              <FormGroup>
                <Label for='sadd3'>District</Label>
                <Input
                  id='sadd3'
                  name='sadd3'
                  value={admissionData.sadd3}
                  onChange={onChangeHandle}
                  type='text'
                />
                {errorMessage.sadd3 && (
                  <FormText color='danger'>{errorMessage.sadd3}</FormText>
                )}
              </FormGroup>
            </div>
            <div className='col-sm-6'>
              <FormGroup>
                <Label for='state_name'>State</Label>
                <Input
                  id='state_name'
                  name='state_name'
                  value={admissionData.state_name}
                  onChange={onChangeHandle}
                  type='text'
                />
                {errorMessage.state_name && (
                  <FormText color='danger'>{errorMessage.state_name}</FormText>
                )}
              </FormGroup>
            </div>
            <div className='col-sm-3'>
              <FormGroup>
                <Label for='pin_code'>Pincode</Label>
                <Input
                  id='pin_code'
                  name='pin_code'
                  value={admissionData.pin_code}
                  onChange={onChangeHandle}
                />
                {errorMessage.name && (
                  <FormText color='danger'>{errorMessage.pin_code}</FormText>
                )}
              </FormGroup>
            </div>
            <div className='col-sm-3'>
              <FormGroup>
                <Label for='living_dur'>Living Since (Duration)</Label>
                <Input
                  id='living_dur'
                  name='living_dur'
                  value={admissionData.living_dur}
                  onChange={onChangeHandle}
                  type='text'
                />
                {errorMessage.living_dur && (
                  <FormText color='danger'>{errorMessage.living_dur}</FormText>
                )}
              </FormGroup>
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-12'>
              <FormGroup>
                <Label for='alt_add'>Alternate Address (if any)</Label>
                <Input
                  id='alt_add'
                  name='alt_add'
                  value={admissionData.alt_add}
                  onChange={onChangeHandle}
                  type='alt_add'
                />
                {errorMessage.alt_add && (
                  <FormText color='danger'>{errorMessage.alt_add}</FormText>
                )}
              </FormGroup>
            </div>
          </div>
        </CardBody>
      </Card>

      <Card className='card-box height-100-p pd-20 mb-20'>
        <CardTitle
          onClick={() => toggleCollapse('parentsDetails')}
          style={{ cursor: 'pointer' }}
          tag='h6'
          className='p-3 mb-0 d-flex align-items-center justify-content-between'
        >
          <div className='d-flex align-items-center'>
            <i className='bi bi-people-fill mr-2'></i> Parents Details
          </div>
          {/* Arrow icon that toggles between up and down */}
          <i
            className={`bi ${openCards.parentsDetails ? 'bi-chevron-up' : 'bi-chevron-down'
              }`}
          ></i>
        </CardTitle>
        <CardBody
          id='parentsDetailsColl'
          className={`accordion-collapse collapse ${openCards.parentsDetails ? 'show' : ''
            }`}
        >
          <div className='table-responsive'>
            <Table hover striped>
              <thead>
                <tr className='text-center'>
                  <th>Info</th>
                  <th>
                    Father's Details <i className='bi bi-person-badge ms-2'></i>
                  </th>
                  <th>
                    Mother's Details <i className='bi bi-person-heart ms-2'></i>
                  </th>
                  <th>
                    Guardian's Details{' '}
                    <i className='bi bi-person-lines-fill ms-2'></i>
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* Father Details */}
                <tr>
                  <th>Name</th>
                  <td>
                    <FormGroup>
                      <Input
                        id='f_name'
                        name='f_name'
                        value={admissionData.f_name}
                        onChange={onChangeHandle}
                        placeholder="Father's Name"
                      />
                      {errorMessage.f_name && (
                        <FormText color='danger'>
                          {errorMessage.f_name}
                        </FormText>
                      )}
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <Input
                        id='m_name'
                        name='m_name'
                        value={admissionData.m_name}
                        onChange={onChangeHandle}
                        placeholder="Mother's Name"
                      />
                      {errorMessage.m_name && (
                        <FormText color='danger'>
                          {errorMessage.m_name}
                        </FormText>
                      )}
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <Input
                        id='g_name'
                        name='g_name'
                        value={admissionData.g_name}
                        onChange={onChangeHandle}
                        placeholder="Guardian's Name"
                      />
                      {errorMessage.g_name && (
                        <FormText color='danger'>
                          {errorMessage.g_name}
                        </FormText>
                      )}
                    </FormGroup>
                  </td>
                </tr>
                <tr>
                  <th>
                    Qualification
                    <i
                      className='bi bi-question-circle float-right text-primary'
                      onClick={() => onHandleMultipleValue('Qualification')}
                    ></i>
                  </th>
                  <td>
                    <FormGroup>
                      <select
                        className='custom-select'
                        id='f_quali'
                        name='f_quali'
                        value={admissionData?.f_quali?.toUpperCase()}
                        onChange={onChangeHandle}
                      >
                        <option value='0'>-Select-</option>
                        {qualificationList.map((option) => (
                          <option
                            key={option.multi_purpose_type}
                            value={option.multi_purpose_type}
                          >
                            {option.multi_purpose_type}
                          </option>
                        ))}
                      </select>
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <select
                        className='custom-select'
                        id='m_quali'
                        name='m_quali'
                        value={admissionData?.m_quali?.toUpperCase()}
                        onChange={onChangeHandle}
                      >
                        <option value='0'>-Select-</option>
                        {qualificationList.map((option) => (
                          <option
                            key={option.multi_purpose_type}
                            value={option.multi_purpose_type}
                          >
                            {option.multi_purpose_type}
                          </option>
                        ))}
                      </select>
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <select
                        className='custom-select'
                        id='g_quali'
                        name='g_quali'
                        value={admissionData?.g_quali?.toUpperCase()}
                        onChange={onChangeHandle}
                      >
                        <option value='0'>-Select-</option>
                        {qualificationList.map((option) => (
                          <option
                            key={option.multi_purpose_type}
                            value={option.multi_purpose_type}
                          >
                            {option.multi_purpose_type}
                          </option>
                        ))}
                      </select>
                    </FormGroup>
                  </td>
                </tr>
                <tr>
                  <th>
                    Profession
                    <i
                      className='bi bi-question-circle float-right text-primary'
                      onClick={() => onHandleMultipleValue('Profession')}
                    ></i>
                  </th>
                  <td>
                    <FormGroup>
                      <select
                        className='custom-select'
                        id='f_prof'
                        name='f_prof'
                        value={admissionData?.f_prof?.toUpperCase()}
                        onChange={onChangeHandle}
                      >
                        <option value='0'>-Select-</option>
                        {profList.map((option) => (
                          <option
                            key={option.multi_purpose_type}
                            value={option.multi_purpose_type}
                          >
                            {option.multi_purpose_type}
                          </option>
                        ))}
                      </select>
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <select
                        className='custom-select'
                        id='m_prof'
                        name='m_prof'
                        value={admissionData?.m_prof?.toUpperCase()}
                        onChange={onChangeHandle}
                      >
                        <option value='0'>-Select-</option>
                        {profList.map((option) => (
                          <option
                            key={option.multi_purpose_type}
                            value={option.multi_purpose_type}
                          >
                            {option.multi_purpose_type}
                          </option>
                        ))}
                      </select>
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <select
                        className='custom-select'
                        id='g_prof'
                        name='g_prof'
                        value={admissionData?.g_prof?.toUpperCase()}
                        onChange={onChangeHandle}
                      >
                        <option value='0'>-Select-</option>
                        {profList.map((option) => (
                          <option
                            key={option.multi_purpose_type}
                            value={option.multi_purpose_type}
                          >
                            {option.multi_purpose_type}
                          </option>
                        ))}
                      </select>
                    </FormGroup>
                  </td>
                </tr>
                <tr>
                  <th>Monthly Income</th>
                  <td>
                    <FormGroup>
                      <Input
                        id='f_income'
                        name='f_income'
                        value={admissionData.f_income}
                        onChange={onChangeHandle}
                        placeholder="Father's Monthly Income"
                      />
                      {errorMessage.f_income && (
                        <FormText color='danger'>
                          {errorMessage.f_income}
                        </FormText>
                      )}
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <Input
                        id='m_income'
                        name='m_income'
                        value={admissionData.m_income}
                        onChange={onChangeHandle}
                        placeholder="Mother's Monthly Income"
                      />
                      {errorMessage.m_income && (
                        <FormText color='danger'>
                          {errorMessage.m_income}
                        </FormText>
                      )}
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <Input
                        id='g_income'
                        name='g_income'
                        value={admissionData.g_income}
                        onChange={onChangeHandle}
                        placeholder="Guardian's Monthly Income"
                      />
                      {errorMessage.g_income && (
                        <FormText color='danger'>
                          {errorMessage.g_income}
                        </FormText>
                      )}
                    </FormGroup>
                  </td>
                </tr>
                <tr>
                  <th>Mobile No.</th>
                  <td>
                    <FormGroup>
                      <Input
                        id='f_mob'
                        name='f_mob'
                        value={admissionData.f_mob}
                        onChange={onChangeHandle}
                        placeholder="Father's Mobile"
                      />
                      {errorMessage.f_mob && (
                        <FormText color='danger'>{errorMessage.f_mob}</FormText>
                      )}
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <Input
                        id='m_mob'
                        name='m_mob'
                        value={admissionData.m_mob}
                        onChange={onChangeHandle}
                        placeholder="Mother's Mobile"
                      />
                      {errorMessage.m_mob && (
                        <FormText color='danger'>{errorMessage.m_mob}</FormText>
                      )}
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <Input
                        id='g_mob'
                        name='g_mob'
                        value={admissionData.g_mob}
                        onChange={onChangeHandle}
                        placeholder="Guardian's Mobile"
                      />
                      {errorMessage.g_mob && (
                        <FormText color='danger'>{errorMessage.g_mob}</FormText>
                      )}
                    </FormGroup>
                  </td>
                </tr>
                <tr>
                  <th>Office Contact No.</th>
                  <td>
                    <FormGroup>
                      <Input
                        id='f_officeph'
                        name='f_officeph'
                        value={admissionData.f_officeph}
                        onChange={onChangeHandle}
                        placeholder="Father's Mobile"
                      />
                      {errorMessage.f_officeph && (
                        <FormText color='danger'>
                          {errorMessage.f_officeph}
                        </FormText>
                      )}
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <Input
                        id='m_officeph'
                        name='m_officeph'
                        value={admissionData.m_officeph}
                        onChange={onChangeHandle}
                        placeholder="Mother's Mobile"
                      />
                      {errorMessage.m_officeph && (
                        <FormText color='danger'>
                          {errorMessage.m_officeph}
                        </FormText>
                      )}
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <Input
                        id='g_officeph'
                        name='g_officeph'
                        value={admissionData.g_officeph}
                        onChange={onChangeHandle}
                        placeholder="Guardian's Mobile"
                      />
                      {errorMessage.g_officeph && (
                        <FormText color='danger'>
                          {errorMessage.g_officeph}
                        </FormText>
                      )}
                    </FormGroup>
                  </td>
                </tr>

                <tr>
                  <th>Aadhar No.</th>
                  <td>
                    <FormGroup>
                      <Input
                        id='f_adhaar_no'
                        name='f_adhaar_no'
                        value={admissionData.f_adhaar_no}
                        onChange={onChangeHandle}
                        placeholder="Father's Aadhaar no."
                      />
                      {errorMessage.f_adhaar_no && (
                        <FormText color='danger'>
                          {errorMessage.f_adhaar_no}
                        </FormText>
                      )}
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <Input
                        id='m_adhaar_no'
                        name='m_adhaar_no'
                        value={admissionData.m_adhaar_no}
                        onChange={onChangeHandle}
                        placeholder="Mother's Aadhaar no."
                      />
                      {errorMessage.m_adhaar_no && (
                        <FormText color='danger'>
                          {errorMessage.m_adhaar_no}
                        </FormText>
                      )}
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <Input
                        id='g_adhaar_no'
                        name='g_adhaar_no'
                        value={admissionData.g_adhaar_no}
                        onChange={onChangeHandle}
                        placeholder="Guardian's Aadhaar no."
                      />
                      {errorMessage.g_adhaar_no && (
                        <FormText color='danger'>
                          {errorMessage.g_adhaar_no}
                        </FormText>
                      )}
                    </FormGroup>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>

      <Card className='card-box height-100-p pd-20 mb-20'>
        <CardTitle
          onClick={() => toggleCollapse("feesDetails")}
          style={{ cursor: "pointer", backgroundColor: "#d3edfa" }}
          tag='h6'
          className='p-3 mb-0 d-flex align-items-center justify-content-between'
        >
          <div className='d-flex align-items-center'>
            <i className='bi bi-currency-rupee mr-2'></i> Fees Details
          </div>
          <i className={`bi ${openCards.feesDetails ? "bi-chevron-up" : "bi-chevron-down"}`}></i>
        </CardTitle>
        <CardBody id='feesDetailsColl' className={`accordion-collapse collapse ${openCards.feesDetails ? "show" : ""}`}>
          <div className='row'>


            <div className='col-sm-4'>
              <FormGroup>
                <Label for='bank_name'>
                  Bank
                </Label>

                <i className="bi bi-question-circle float-right text-primary"
                  onClick={() => onHandleMultipleValue('Bank')}>
                </i>
                <select
                  className='custom-select'
                  id='bank_name'
                  name='bank_name'
                  value={admissionData.bank_name}
                  onChange={onChangeHandle}
                >
                  <option value='0'>Select Bank</option>
                  {bankList.map((option) => (
                    <option
                      key={option.multi_purpose_type}
                      value={option.multi_purpose_type}
                    >
                      {option.multi_purpose_type}
                    </option>
                  ))}
                </select>
                {errorMessage.bank_name && (
                  <FormText color='danger'>
                    {errorMessage.bank_name}
                  </FormText>
                )}
              </FormGroup>
            </div>

            <div className='col-sm-4'>
              <FormGroup>
                <Label for='bank_ac_no'>Bank A/C No.</Label>
                <Input
                  id='bank_ac_no'
                  name='bank_ac_no'
                  value={admissionData.bank_ac_no}
                  onChange={onChangeHandle}
                />
                {errorMessage.name && (
                  <FormText color='danger'>
                    {errorMessage.bank_ac_no}
                  </FormText>
                )}
              </FormGroup>
            </div>
            <div className='col-sm-4'>

              <FormGroup>
                <Label for='op_bal'>Fees Opening Balance</Label>
                <Input
                  id='op_bal'
                  name='op_bal'
                  value={admissionData.op_bal}
                  onChange={onChangeHandle}
                />
                {errorMessage.name && (
                  <FormText color='danger'>
                    {errorMessage.op_bal}
                  </FormText>
                )}
              </FormGroup>
            </div>
          </div>

          <div className='row'>
            <div className='col-sm-4'>
              <FormGroup>
                <Label for='fee_group_id'>Fee Group Name</Label>
                <select
                  className='custom-select'
                  id='fee_group_id'
                  name='fee_group_id'
                  value={admissionData.fee_group_id}
                  onChange={onChangeHandle}
                >
                  <option value='0'>- Select Fee Group -</option>
                  {Fee_Group_data.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.fee_group_name}
                    </option>
                  ))}
                </select>

                {errorMessage.fee_group_id && (
                  <FormText color='danger'>
                    {errorMessage.fee_group_id}
                  </FormText>
                )}
              </FormGroup>
            </div>
            <div className='col-sm-4'>
              <FormGroup>
                <Label for='slabMstId'>Fees Slab Name</Label>
                <select
                  className='custom-select'
                  id='slabMstId'
                  name='slabMstId'
                  value={String(admissionData.slabMstId)}
                  onChange={onChangeHandle}
                >
                  <option value='0'>- Select Fee Slab -</option>
                  {SlabMaster?.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.slab_name}
                    </option>
                  ))}
                </select>

                {errorMessage.slabMstId && (
                  <FormText color='danger'>
                    {errorMessage.slabMstId}
                  </FormText>
                )}
              </FormGroup>
            </div>
            <div className='col-sm-4'>
              <FormGroup>
                <Label for='barcode_no'>BarCode</Label>
                <Input
                  id='barcode_no'
                  name='barcode_no'
                  value={admissionData.barcode_no}
                  onChange={onChangeHandle}
                  type='text'
                />
                {errorMessage.barcode_no && (
                  <FormText color='danger'>
                    {errorMessage.barcode_no}
                  </FormText>
                )}
              </FormGroup>
            </div>
            <div className='col-sm-12'>
                            <FormGroup>
                              <Label for='fee_group_id'></Label>
                              <Button
                                size='sm'
                                className='form-control text-light'
                                color='success'
                                onClick={generateInstallments}
                              >
                                {' '}
                                <i className='bi bi-check-circle mr-2' />
                               {admissionResp.installmentExists ? "Generate Installments Again" : "Generate New Installments" }  
                              </Button>
                            </FormGroup>
                          </div>
          </div>

          <div className="table-responsive">
            <table className="table table-bordered text-center">
              <thead className="table-info">
                <tr>
                  <th colSpan={2}> <i className="bi bi-cash-stack me"></i> Monthly Fees Structure</th>
                </tr>
                <tr>
                  <th width="50%">Months</th>
                  <th width="50%">Fees (₹)</th>
                </tr>
              </thead>
              <tbody>
                {(!SlabMasterTotalMont || Object.keys(SlabMasterTotalMont).length === 0) ?
                  <tr>
                    <td colSpan={2}>Please select a slab to see the monthly structure</td>
                  </tr>

                  :

                  <>
                    <tr><td>April (1) </td><td>{SlabMasterTotalMont.month_tot_1}</td></tr>
                    <tr><td>May (2) </td><td>{SlabMasterTotalMont.month_tot_2}</td></tr>
                    <tr><td>June (3)</td><td>{SlabMasterTotalMont.month_tot_3}</td></tr>
                    <tr><td>July (4)</td><td>{SlabMasterTotalMont.month_tot_4}</td></tr>
                    <tr><td>August (5)</td><td>{SlabMasterTotalMont.month_tot_5}</td></tr>
                    <tr><td>September (6)</td><td>{SlabMasterTotalMont.month_tot_6}</td></tr>
                    <tr><td>October (7)</td><td>{SlabMasterTotalMont.month_tot_7}</td></tr>
                    <tr><td>November (8)</td><td>{SlabMasterTotalMont.month_tot_8}</td></tr>
                    <tr><td>December (9)</td><td>{SlabMasterTotalMont.month_tot_9}</td></tr>
                    <tr><td>January (10)</td><td>{SlabMasterTotalMont.month_tot_10}</td></tr>
                    <tr><td>February (11)</td><td>{SlabMasterTotalMont.month_tot_11}</td></tr>
                    <tr><td>March (12)</td><td>{SlabMasterTotalMont.month_tot_12}</td></tr>

                    <tr className='border-top'><th className='table-primary'>Total Fees (₹)</th><th className='table-primary'>{SlabMasterTotalMont.fee_tot}</th></tr>
                  </>
                }
              </tbody>
            </table>
          </div>

        </CardBody>
      </Card>

      <Card className='card-box height-100-p pd-20 mb-20'>
        <CardTitle
          onClick={() => toggleCollapse("conveyanceDetails")}
          style={{ cursor: "pointer" }}
          tag='h6'
          className='p-3 mb-0 d-flex align-items-center justify-content-between'
        >
          <div className='d-flex align-items-center'>
            <i className='bi bi-bus-front-fill mr-2'></i> Conveyance Details
          </div>
          <i className={`bi ${openCards.conveyanceDetails ? "bi-chevron-up" : "bi-chevron-down"}`}></i>
        </CardTitle>
        <CardBody id='conveyanceDetailsColl' className={`accordion-collapse collapse ${openCards.conveyanceDetails ? "show" : ""}`}>

          <div className='row'>
            <div className='col-sm-6'>

              <FormGroup>
                <Label for='cov_yn'>Do the student use conveyance? [Yes/No]</Label>

                <select
                  className='custom-select'
                  id='cov_yn'
                  name='cov_yn'
                  value={admissionData.cov_yn}
                  onChange={onChangeHandle}
                >
                  {ConveyanceList.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </FormGroup>
            </div>
            {admissionData.cov_yn === "YES" &&
              <>
                <div
                  className='col-sm-6'
                >
                  <FormGroup>
                    <Label for='con_det'>Mode of Transport</Label>
                    <Input
                      id='con_det'
                      name='con_det'
                      value={admissionData.con_det}
                      onChange={onChangeHandle}
                    />
                    {errorMessage.con_det && (
                      <FormText color='danger'>
                        {errorMessage.con_det}
                      </FormText>
                    )}
                  </FormGroup>
                </div>
                <div
                  className='col-sm-6'

                >
                  <FormGroup>
                    <Label for='category_class'>Driver Name </Label>
                    <select
                      className='custom-select'
                      name='transport_id'
                      value={admissionData.transport_id}
                      onChange={onChangeHandle}
                    >
                      <option value='0'>Select Transport Driver</option>
                      {transportList.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.driver_name}
                        </option>
                      ))}
                    </select>
                  </FormGroup>
                </div>

                <div
                  className='col-sm-6'

                >
                  <FormGroup>
                    <Label for='phone_no'>Driver Mobile No.</Label>
                    <Input
                      type='text'
                      id='phone_no'
                      name='phone_no'
                      readOnly
                      value={TransportData.phone_no}
                    />
                  </FormGroup>
                </div>
                <div className='col-sm-6'>
                  <FormGroup>
                    <Label for='car_name'>
                      Vehicle Model
                    </Label>

                    <i className="bi bi-question-circle float-right"
                      onClick={() => onHandleMultipleValue('CarName')}>
                    </i>
                    <Select
                      defaultValue={[]}
                      isMulti
                      name='car_name'
                      options={carOptions}
                      className='basic-multi-select'
                      classNamePrefix='select'
                      value={TransportData.car_name1}
                    />
                  </FormGroup>
                </div>
                <div className='col-sm-6'>
                  <FormGroup>
                    <Label for='address'>Vehical No.</Label>
                    <Input
                      type='text'
                      id='vehicle_no'
                      name='vehicle_no'
                      readOnly
                      value={TransportData.vehicle_no}
                    />
                  </FormGroup>
                </div>
                <div className='col-sm-6'>
                  <FormGroup>
                    <Label for='driving_licence_no'>
                      Driving Licence No.
                    </Label>
                    <Input
                      type='text'
                      id='driving_licence_no'
                      name='driving_licence_no'
                      value={TransportData.driving_licence_no}
                      onChange={onChangeHandle}
                    />
                  </FormGroup>
                </div>
                <div className='col-sm-6'>
                  <FormGroup>
                    <Label for='aadhar_card_no'>Aadhar Card No</Label>
                    <Input
                      type='text'
                      id='aadhar_card_no'
                      name='aadhar_card_no'
                      value={TransportData.aadhar_card_no}
                      onChange={onChangeHandle}
                    />
                  </FormGroup>
                </div>

                <div className='col-sm-12'>
                  <FormGroup>
                    <Label for='address'>Driver's Address</Label>
                    <Input
                      type='text'
                      id='address'
                      name='address'
                      readOnly
                      value={TransportData.address}
                    />
                  </FormGroup>
                </div>
              </>
            }
          </div>

        </CardBody>
      </Card>

      <Card className='card-box height-100-p pd-20 mb-20'>
        <CardTitle
          onClick={() => toggleCollapse('siblingDetails')}
          style={{ cursor: 'pointer', backgroundColor: '#d3edfa' }}
          tag='h6'
          className='p-3 mb-0 d-flex align-items-center justify-content-between'
        >
          <div className='d-flex align-items-center'>
            <i className='bi bi-person-lines-fill mr-2'></i> Sibling Details
          </div>
          {/* Arrow icon that toggles between up and down */}
          <i
            className={`bi ${openCards.siblingDetails ? 'bi-chevron-up' : 'bi-chevron-down'
              }`}
          ></i>
        </CardTitle>
        <CardBody
          id='siblingDetailsColl'
          className={`accordion-collapse collapse ${openCards.siblingDetails ? 'show' : ''
            }`}
        >
          <div className='row'>
            <div className='col-sm-4'>
              <FormGroup>
                <Label for='sibling_adm_no'>Admission No.</Label>
                <Input
                  id='sibling_adm_no'
                  name='sibling_adm_no'
                  value={siblingAdmid}
                  onChange={handleInputChange}
                />
                {errorMessage.sibling_adm_no && (
                  <FormText color='danger'>
                    {errorMessage.sibling_adm_no}
                  </FormText>
                )}
              </FormGroup>
            </div>
            <div className='col-sm-3'>
              <FormGroup>
                <Label for='fee_amt'>Action</Label>
                <Button
                  color='primary'
                  className='form-control text-white'
                  onClick={addSiblingTData}
                >
                  <i className='bi bi-plus' /> Add New Sibling
                </Button>
              </FormGroup>
            </div>
          </div>

          <div className='table-responsive border-top'>
            <Table hover striped responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Adm no</th>
                  <th>Sibling Name</th>
                  <th>Class</th>
                  <th>Adm Date</th>
                  <th>Roll no</th>
                </tr>
              </thead>
              <tbody>
                {siblingTransection.length ? (
                  siblingTransection.map((item, index) => (
                    <tr>
                      <td>
                        <i
                          onClick={() => {
                            deleteSiblingTData(index, item.id);
                          }}
                          className='bi bi-trash text-danger'
                        />
                      </td>
                      <td>{item.adm_no}</td>
                      <td>{item.sibling_Name}</td>
                      <td>{item.sibling_class}</td>
                      <td>{item.adm_date}</td>
                      <td>{item.roll_no}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className='text-center' colSpan={6}>
                      No Siblings Added till now under this slab...
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>

      <Card className='card-box height-100-p pd-20 mb-20'>
        <CardTitle
          onClick={() => toggleCollapse("tcDetails")}
          style={{ cursor: "pointer" }}
          tag='h6'
          className='p-3 mb-0 d-flex align-items-center justify-content-between'
        >
          <div className='d-flex align-items-center'>
            <i className='bi bi-file-text mr-2'></i> Student A/c & TC Issue Details
          </div>
          <i className={`bi ${openCards.tcDetails ? "bi-chevron-up" : "bi-chevron-down"}`}></i>
        </CardTitle>
        <CardBody id='tcDetailsColl' className={`accordion-collapse collapse ${openCards.tcDetails ? "show" : ""}`}>
          <div className='row'>
            <div className='col-sm-6'>

              <FormGroup>
                <Label for='ac_close_yn'>A/c Close</Label>
                <select
                  className='custom-select'
                  id='ac_close_yn'
                  name='ac_close_yn'
                  value={admissionData.ac_close_yn}
                  onChange={onChangeHandle}
                >
                  {optionsAcClose.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>

                {errorMessage.name && (
                  <FormText color='danger'>
                    {errorMessage.ac_close_yn}
                  </FormText>
                )}
              </FormGroup>
            </div>
            <div className='col-sm-6'>

              <FormGroup>
                <Label for='ac_close_date'>Ac Close Date</Label>
                <Input
                  id='ac_close_date'
                  name='ac_close_date'
                  value={formatDate(admissionData.ac_close_date, "YYYY-MM-DD")}
                  onChange={onChangeHandle}
                  type='date'
                />
                {errorMessage.ac_close_date && (
                  <FormText color='danger'>
                    {errorMessage.ac_close_date}
                  </FormText>
                )}
              </FormGroup>
            </div>
            <div className='col-sm-6'>

              <FormGroup>
                <Label for='tc_issue_yn'>TC Issued [Yes/No]</Label>
                <select
                  className='custom-select'
                  id='tc_issue_yn'
                  name='tc_issue_yn'
                  value={admissionData.tc_issue_yn}
                  onChange={onChangeHandle}
                >
                  {optionsTcIssue.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
                {errorMessage.tc_issue_yn && (
                  <FormText color='danger'>
                    {errorMessage.tc_issue_yn}
                  </FormText>
                )}
              </FormGroup>
            </div>
            <div className='col-sm-6'>
              <FormGroup>
                <Label for='tc_issue_date'>TC Issue Date</Label>
                <Input
                  id='tc_issue_date'
                  name='tc_issue_date'
                  value={formatDate(admissionData.tc_issue_date, "YYYY-MM-DD")}
                  onChange={onChangeHandle}
                  type='date'
                />
                {errorMessage.tc_issue_date && (
                  <FormText color='danger'>
                    {errorMessage.tc_issue_date}
                  </FormText>
                )}
              </FormGroup>
            </div>
          </div>
        </CardBody>
      </Card>

      <Modal centered isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          Add new {Multi_Purpose_Type_MasterData.multi_purpose_flag}
        </ModalHeader>
        <ModalBody>
          <Form>
            <div
              className='accordion accordion-flush'
              id='accordionFlushExample'
            >
              {/* <FormGroup>
                <Label for='multi_purpose_code'>Multi_Purpose_Code</Label>
                <Input
                  id='multi_purpose_code'
                  name='multi_purpose_code'
                  value={Multi_Purpose_Type_MasterData.multi_purpose_code}
                  onChange={onChangeHandle1}
                />
                {errorMessage.multi_purpose_code && (
                  <FormText color='danger'>
                    {errorMessage.multi_purpose_code}
                  </FormText>
                )}
              </FormGroup> */}
              <FormGroup>
                <Label for='multi_purpose_type'>
                  Enter new {Multi_Purpose_Type_MasterData.multi_purpose_flag}{' '}
                  option detail :
                </Label>
                <Input
                  id='multi_purpose_type'
                  name='multi_purpose_type'
                  value={Multi_Purpose_Type_MasterData.multi_purpose_type}
                  onChange={onChangeHandle1}
                />
                {errorMessage.multi_purpose_type && (
                  <FormText color='danger'>
                    {errorMessage.multi_purpose_type}
                  </FormText>
                )}
              </FormGroup>
              {/* <FormGroup>
                <FormGroup>
                  <Label for='multi_purpose_flag'>
                    Multi_Purpose_Flag
                  </Label>
                  <Input
                    id='multi_purpose_flag'
                    name='multi_purpose_flag'
                    readOnly
                    value={
                      Multi_Purpose_Type_MasterData.multi_purpose_flag
                    }
                    onChange={onChangeHandle1}
                  />
                  {errorMessage.multi_purpose_flag && (
                    <FormText color='danger'>
                      {errorMessage.multi_purpose_flag}
                    </FormText>
                  )}
                </FormGroup>
                <Label for='multi_purpose_remark'>Remark</Label>
                <Input
                  id='multi_purpose_remark'
                  name='multi_purpose_remark'
                  value={
                    Multi_Purpose_Type_MasterData.multi_purpose_remark
                  }
                  onChange={onChangeHandle1}
                />
                {errorMessage.multi_purpose_remark && (
                  <FormText color='danger'>
                    {errorMessage.multi_purpose_remark}
                  </FormText>
                )}
              </FormGroup> */}
            </div>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            className='mt-2'
            color='primary'
            onClick={save_multi_purpose_master}
          >
            Submit
          </Button>
          <Button color='secondary' onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AddAdmissionNew;
